<button mat-flat-button (click)="clicked.emit()" [disabled]="disabled"
    style="border-radius: 5px;  width: 100%; padding: 0px 14px; justify-content: flex-start;"
    [style.height]="height">
    <div style="display: flex; flex-direction: row; align-items: center; height: 100%;"
        [ngStyle]="{ 'justify-content': icon === '' ? 'center' : 'flex-start' }">
        <div *ngIf="(icon !== '');else noIcon" style="display: flex; 
        justify-content: flex-start;  align-items: center; height: 100%; gap: 12px;">
            <div class="icon-frame" style="display: flex; align-items: center; height: 100%;">
                <i class="{{icon}}" [style.fontSize]="size" style="margin-right: 12px"
                    [ngClass]="{'single-color-icon':!disabled && type === 'action', 'icon': !disabled && type === 'default','disabled': disabled}"></i>
            </div>
            <div style="font-size: 14px;" [ngClass]="{'single-color-icon':type === 'action','disabled': disabled}">
                {{label}}</div>
        </div>
        <ng-template #noIcon>
            <div style="font-size: 14px;" [ngClass]="{'single-color-icon':type === 'action','disabled': disabled}">
                {{label}}</div>
        </ng-template>
    </div>
</button>